export default `{ path: '/feedback', component: CannyWidget },
{ path: '/feedback/*', component: CannyWidget },`;
